import React, { useEffect, useRef, useState } from "react";
import "./homeSection.css";

const Kits = ({ title, description, buttonText, image, buttonLink }) => {
    const [isVisible, setIsVisible] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0.1 }
        );

        if (containerRef.current) observer.observe(containerRef.current);

        return () => {
            if (containerRef.current) observer.unobserve(containerRef.current);
        };
    }, []);

    return (
        <div
            ref={containerRef}
            className={`home-section home-section--orange ${isVisible ? "visible" : ""}`}
        >
            <div className="home-section__container">
                <div className="home-section__text text-side">
                    <h2 className="home-section__heading">{title}</h2>
                    <p className="home-section__description">{description}</p>
                    <a href={buttonLink} className="home-section__cta">
                        {buttonText}
                    </a>
                </div>
                <div className="home-section__frame image-side">
                    <img src={image} alt="kit" />
                </div>
            </div>
        </div>
    );
};

export default Kits;
